import type { JSX } from 'react'

import { PartnerProgramCoverMobileSC } from './PartnerProgramCover.styled'

export const PartnerProgramCoverMobile = (): JSX.Element => (
  <PartnerProgramCoverMobileSC
    viewBox='0 0 714 1080'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    preserveAspectRatio='none'
  >
    <g clipPath='url(#clip0_743_35745)'>
      <rect width='714' height='1080' fill='#0D0D0D' />
      <path
        d='M149.854 1559.6C-173.593 1340.49 -809.288 1002.11 -739.974 162.926C-688.063 -465.576 268.514 -869.648 214.854 -346.468C161.195 176.713 -416.128 -246.857 929.832 -452.552C2275.79 -658.247 1348.25 1107.97 605.96 1116.91C-136.33 1125.85 427.095 -153.033 1603.13 -260.352M-302.106 -194.32C21.1889 -199.943 533.681 67.97 -2.70679 1184.6'
        stroke='url(#paint0_linear_743_35745)'
        strokeWidth='160'
      />
      <path
        d='M1756.02 -178.833C1895.09 282.867 2034.58 1277.04 1479.95 1560.11C786.659 1913.96 313.382 1280.04 772.206 820.869C1231.03 361.694 1575.86 1958.26 126.869 1107.01C-1322.13 255.757 256.79 -679.667 974.524 -110.148C1692.26 459.371 156.785 1245.16 -1052.89 432.047'
        stroke='url(#paint1_linear_743_35745)'
        strokeWidth='173.763'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_743_35745'
        x1='497.987'
        y1='-260.352'
        x2='497.987'
        y2='1559.6'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#303030' />
        <stop offset='1' />
      </linearGradient>
      <linearGradient
        id='paint1_linear_743_35745'
        x1='164.213'
        y1='981.457'
        x2='1365.94'
        y2='-496.095'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#303030' />
        <stop offset='1' />
      </linearGradient>
      <clipPath id='clip0_743_35745'>
        <rect width='714' height='1080' fill='white' />
      </clipPath>
    </defs>
  </PartnerProgramCoverMobileSC>
)
